// extracted by mini-css-extract-plugin
module.exports = {"form":"InformationStep_form__3CI09","inputs":"InformationStep_inputs__2OINP","textArea":"InformationStep_textArea__3I455","buttons":"InformationStep_buttons__UkY5S"};